import * as React from "react";
const SVGComponent = (props) => {
    const specificPath = window.location.pathname === "/home";

    return (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 7.5 10 1.667 17.5 7.5v9.167a1.666 1.666 0 0 1-1.667 1.666H4.167A1.667 1.667 0 0 1 2.5 16.667z"
      stroke={specificPath ? "#ffffff" : "#667085"}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 18.333V10h5v8.333"
      stroke={specificPath ? "#ffffff" : "#667085"}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
    )
};
export default SVGComponent;
